module.exports = __webpack_public_path__ + "img/logo.94146978.png";